/*  MUI  */
import { Download } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

/*  Shared  */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';
import { FontSizes, URLs } from 'application/Shared/Constants';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';
import { MobileConfigDownload } from './Components/MobileConfigDownload';

const PreStepNote = () => {
    const { t } = useTranslation();
    return (
        <Box data-testid="addigyPreStepNote">
            <Typography style={{ lineHeight: '24px', marginBottom: '4px' }}>
                {t('Integrations.addigy.preStep')}
            </Typography>
            <ul>
                <li className="li-with-spacing">
                    {t('Integrations.addigy.preStep.substep1')}
                </li>
                <li className="li-with-spacing">
                    {t('Integrations.addigy.preStep.substep2')}
                </li>
            </ul>
        </Box>
    );
};

const deploymentSteps = ({ onboarding, t }) => [
    {
        component: (
            <Typography variant="h4">
                {t('Integrations.setup_process')}
            </Typography>
        ),
        step: false
    },
    {
        component: <PreStepNote />,
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step1')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step2')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <MobileConfigDownload stepText={t('Integrations.addigy.step3')} />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step4')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step5')
                }}
            />
        ),
        step: true
    },
    {
        note: (
            <Box>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.addigy.note')
                    }}
                />
            </Box>
        ),
        step: false
    },
    {
        component: (
            <Typography variant="h4" style={{ marginTop: '16px' }}>
                {t('Integrations.deployingThePackage')}
            </Typography>
        ),
        step: false
    },
    {
        component: (
            <Box display="flex" alignItems="center">
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.addigy.step6')
                    }}
                />
                <a
                    href={`${URLs.publicFiles}/Saaslio.pkg`}
                    data-trackid="partner_integrations_addigy_download_file"
                >
                    <Button
                        data-trackid="partner_integrations_addigy_download"
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: '8px' }}
                        size="small"
                    >
                        <Download
                            style={{
                                fontSize: FontSizes[2],
                                marginRight: '4px'
                            }}
                        />
                        {t('Integrations.Custom.makeMacMDM.step2.filename')}
                    </Button>
                </a>
            </Box>
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step7')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step8')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.step9')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Box width="100%">
                {t('Integrations.addigy.step10')}
                <CustomScript onboarding={onboarding} forAddigy />
            </Box>
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.addigy.bottomNote')
                }}
            />
        ),
        step: false
    }
];

export const Addigy = ({ onboarding = false }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    return (
        <IntegrationWrapper
            hasToken
            deploymentSteps={deploymentSteps({ onboarding, t })}
            headerTitle={t('Integrations.addigy.title')}
            img={`/images/${userTheme}/integrations/addigy.png`}
            imgWidth="200px"
            onboarding={onboarding}
        />
    );
};
